<template>
  <div class="Dropdown__multiple__search">
    <div style="display: flex;">
      <input
        class="input"
        type="search"
        v-model="query"
        :placeholder="label"
      /><button class="button" @click="open = !open">
        <i class="fa" :class="`fa-caret-${open ? 'up' : 'down'}`"></i></button
      ><button class="button" @click="clear" :disabled="selected.length === 0">
        <i class="fa fa-times-circle"></i>
      </button>
    </div>
    <div class="Dropdown__multiple__search__list" v-show="open">
      <div class="Dropdown__multiple__search__list__inside">
        <div v-for="(i, index) in filtered" :key="index">
          <label
            @click="
              selected.indexOf(primitive ? i : i.id) !== -1
                ? deselect(i)
                : select(i)
            "
            style="cursor: pointer;"
            ><input
              type="checkbox"
              :checked="selected.indexOf(primitive ? i : i.id) !== -1"
              @click.prevent=""
            />&nbsp;{{ primitive ? i : i[displayKey] }}</label
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "dropdown-multiple-search",
  data() {
    return {
      open: false,
      query: ""
    };
  },
  methods: {
    select(item) {
      if (this.primitive) this.$emit("selection", this.selected.concat([item]));
      else this.$emit("selection", this.selected.concat([item.id]));
    },
    deselect(item) {
      if (this.primitive)
        this.$emit("selection", this.selected.filter(i => i !== item));
      else this.$emit("selection", this.selected.filter(i => i !== item.id));
    },
    clear() {
      this.$emit("selection", []);
    }
  },
  computed: {
    selectedCount() {
      return this.selected.length;
    },
    filtered() {
      let c;
      if (this.query.trim().length === 0) {
        c = this.items;
      } else {
        if (this.primitive) {
          c = this.items.filter(
            i => i.toLowerCase().indexOf(this.query.toLowerCase()) !== -1
          );
        } else {
          c = this.items.filter(
            i =>
              i[this.displayKey]
                .toLowerCase()
                .indexOf(this.query.toLowerCase()) !== -1
          );
        }
      }
      if (this.primitive) return c.slice(0).sort((b, a) => (a > b ? -1 : 1));
      return c.slice(0).sort((b, a) => (a.slug > b.slug ? -1 : 1));
    }
  },
  props: {
    label: {
      type: String,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    selected: {
      type: Array,
      required: true
    },
    displayKey: {
      type: String,
      default: "name"
    },
    dataKey: {
      type: String,
      default: "id"
    },
    primitive: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    query() {
      this.open = true;
    }
  }
};
</script>

<style lang="scss">
.Dropdown__multiple__search {
  display: inline-block;
  width: 100%;
  position: relative;
  z-index: 2;
  &__list {
    position: absolute;
    padding: 10px;
    box-shadow: 0 8px 10px rgba(0, 0, 0, 0.5);
    width: 100%;
    top: 2.5em;
    max-height: 400px;
    left: 0;
    background: whitesmoke;
    overflow-y: scroll;
    font-size: 11px;
    &__inside {
      padding-bottom: 10px;
    }
  }
}
</style>
